module.exports = __webpack_public_path__ + "public/SiteImages/instagram.svg?89ed7482";